module.exports = __webpack_public_path__ + "img/blueuparw.a123425a.svg";